
import React, { useEffect, useState } from 'react';
import { TonConnectButton, useTonAddress } from '@tonconnect/ui-react';
import './App.css';
import axios from 'axios';

// Localization
const translations = {
  ru: {
    title: 'Подключить TON кошелек для проверки карты коллекции',
    subtitle: 'В зависимости от редкости карты будут начислены бонусы в TON Poker.',
    rarities: {
      common: 'Common — $3',
      rare: 'Rare — $5',
      epic: 'Epic — $7',
      legendary: 'Legendary — $10'
    },
    connectButton: 'Подключить кошелек',
    walletConnected: 'Кошелёк успешно подключён',
    goToPoker: 'Перейти в TON Poker'
  },
  en: {
    title: 'Connect your TON wallet to verify the collection card',
    subtitle: 'Depending on card rarity, you will receive bonuses in TON Poker.',
    rarities: {
      common: 'Common — $3',
      rare: 'Rare — $5',
      epic: 'Epic — $7',
      legendary: 'Legendary — $10'
    },
    connectButton: 'Connect wallet',
    walletConnected: 'Wallet successfully connected',
    goToPoker: 'Go to TON Poker'
  }
} as const;

type Lang = keyof typeof translations;

function App() {
  const userAddress = useTonAddress();
  const [isConnected, setIsConnected] = useState(false);
  const [lang, setLang] = useState<Lang>('en');

  // флаг, чтобы POST выполнялся ровно один раз за сессию
  const [walletSaved, setWalletSaved] = useState(false);

  // Detect language from URL or browser
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');

    if (urlLang === 'ru') {
      setLang('ru');
    } else if (navigator.language.startsWith('ru')) {
      setLang('ru');
    } else {
      setLang('en');
    }
  }, []);

  // Watch TON wallet connection
  useEffect(() => {
    setIsConnected(!!userAddress);
  }, [userAddress]);

  // Save wallet once
  useEffect(() => {
    if (userAddress && !walletSaved) {
      const urlParams = new URLSearchParams(window.location.search);
      const userId = urlParams.get('user_id') ?? '';
      const username = urlParams.get('username') ?? '';

      axios.post('https://md-api.4815162.xyz/api/save-wallet', {
        user_id: userId,
        username: username,
        wallet_address: userAddress
      })
      .then(() => {
        console.log('Wallet saved successfully');
      })
      .catch((error) => {
        console.error('Error saving wallet:', error);
      })
      .finally(() => {
        setWalletSaved(true);
      });
    }
  }, [userAddress, walletSaved]);

  const t = translations[lang];

  const formatAddress = (address: string) => (address ? `${address.slice(0, 4)}...${address.slice(-4)}` : '');

  const handleGoToPoker = () => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    }
    window.location.href = 'https://t.me/tonpoker/lobby?startapp=eyJ0eXBlIjoibG9iYnkiLCJjaWQiOiJnZXRnZW1zIn0';
  };

  return (
    <div className="App">
      <div className="container">
        {!isConnected ? (
          <>
            <h1 className="title">{t.title}</h1>
            <p className="subtitle">{t.subtitle}</p>

            <div className="rarities-list">
              {Object.values(t.rarities).map((rarity, index) => (
                <div key={index} className="rarity-item">
                  {rarity}
                </div>
              ))}
            </div>

            <div className="connect-button-wrapper">
              <TonConnectButton />
            </div>
          </>
        ) : (
          <div className="connected-state">
            <div className="success-icon">✓</div>
            <h2 className="connected-title">{t.walletConnected}</h2>
            <p className="wallet-address">{formatAddress(userAddress)}</p>
            <button className="poker-button" onClick={handleGoToPoker}>
              {t.goToPoker}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Extend window interface for Telegram WebApp
declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        close: () => void;
      };
    };
  }
}

export default App;
